import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as queryString from 'query-string'

import { ButtonControl } from '../../components/common'
import { Filters } from '../../components/features'
import {
	getIsLegalFlow,
	getUserId,
	setImageFilter,
} from '../../redux/slices/userSlice'
import { getInitialPrice, getUpsellPrice } from '../../redux/slices/configSlice'
import { ampEventWithEventProperty } from '../../utils/amplitude'
import { paramsToQuery } from '../../utils/historyDecorators'

import './styles.scss'

const FeaturesScreen = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const params = queryString.parse(location.search)

	const [filter, setFilter] = useState('')
	const [isActive, setIsActive] = useState(false)
	const isLegalFlow = useSelector(getIsLegalFlow)
	const user_id = useSelector(getUserId)
	const upsell_test = params?.upsell_test || useSelector(getUpsellPrice)
	const initial_price = params?.initial_price || useSelector(getInitialPrice)

	const handleSubmitFilterType = () => {
		ampEventWithEventProperty('Question_answered', { question: '2' })
		dispatch(setImageFilter({ filterType: filter }))
		setIsActive(false)
		setTimeout(
			() =>
				history.push({
					pathname: '/processing',
					search: isLegalFlow
						? paramsToQuery({ user_id, external_id: user_id })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
						  }),
				}),
			350,
		)
	}

	useEffect(() => setTimeout(() => setIsActive(true), 350), [])

	return (
		<div className={`features ${isActive ? 'features--active' : ''}`}>
			<Filters filter={filter} setFilter={setFilter} />
			<ButtonControl
				buttonText="Next"
				onClick={handleSubmitFilterType}
				disabled={!filter}
			/>
		</div>
	)
}

export { FeaturesScreen }
